import { getLocalAgent } from "./configResolver";

/**
 * Create a URL needed by the HTTP_Launcher constructor, then
 * create the launcher.
 */
let localAgent = getLocalAgent();
let localURL = localAgent.ssl == true ? "https://" : "http://";
localURL += localAgent.host + ":" + localAgent.portDefault;

export { localURL };
